module.exports = __webpack_public_path__ + "cac763b4cc3104c45ae14710cea65bf9.MP3";